import React, {useEffect, useState} from "react";
import {
  closePopup,
  getTime,
  getValue,
  openPopup,
  reloadPopup,
  setValue
} from "../../static/js/Common2";
import closeV2 from "../../static/image/v2/popup/closeV2.png";
import closeBtn from "../../static/image/v2/shop/closeBtn.png";
import openBtn from "../../static/image/v2/shop/openBtn.png";
import plusBtn from "../../static/image/v2/popup/plusBtn.png";
import minusBtn from "../../static/image/v2/popup/minusBtn.png";
import "static/css/popup.css";
import {getShopInfoApi, setShopPauseApi} from "../../api/shopApi";
import {getShopList} from "../../utils/CommonUtils";
import { getDownShopListApi } from "../../api/shopApi";




const ShopStatus = {
  PAUSE: 5,        // 일시정지
  OPERATE: 6,      // 영업중
  OPERATE_STOP: 7, // 영업중지
  TEMP_CLOSING: 12 // 임시중지
};


const ShopStopPopup = () => {
  const [openShop, setOpenShop] = useState([]);
  const [closeShop, setCloseShop] = useState([]);



  // useEffect(() => {
  //   const fetchShops = async () => {
  //     const shopList = await getShopList();
  //     const results = await Promise.all(
  //         shopList.map(async (value) => {
  //           const shopData = await getShopInfoApi(value.id);
  //           return {
  //             id: value.id,          // 원래의 value.id 보존
  //             name: shopData.name,   // 결과값에서 필요한 정보
  //             status: shopData.status,
  //           };
  //         })
  //     );

  //     const open = [];
  //     const close = [];

  //     results.forEach((shop) => {
  //       if (shop.status === 5) {
  //         close.push({ id: shop.id, name: shop.name });
  //       } else if (shop.status === 6) {
  //         open.push({ id: shop.id, name: shop.name });
  //       }
  //     });

  //     setOpenShop(open);
  //     setCloseShop(close);
  //   };

  //   fetchShops();
  // }, []);

  useEffect(() => {
    // TODO: 영업일시중지 API 연동 미완성 - 배포 제외
  // const fetchShops = async () => {
  //   const userType = Number(sessionStorage.getItem("userType"));
  //   const userId = Number(sessionStorage.getItem("userId"));

  //   const data = await getDownShopListApi(userType, userId, null);
  //   const shopList = data.shopList;

  //   const open = [];
  //   const close = [];

  //   shopList.forEach((shop) => {
  //     const entry = { id: shop.id, name: shop.storeName };

  //     if (shop.statusTpcd === ShopStatus.OPERATE) {
  //       // 영업중 → 일시정지 설정 대상
  //       open.push(entry);
  //     } else if ([ShopStatus.PAUSE, ShopStatus.OPERATE_STOP, ShopStatus.TEMP_CLOSING].includes(shop.statusTpcd)) {
  //       // 일시정지/영업중지/임시중지 → 해제 대상
  //       close.push(entry);
  //     }
  //   });

  //   setOpenShop(open);
  //   setCloseShop(close);
  // };

  // fetchShops();
}, []);

  // 오픈 중인 상점 리스트 생성
  const openShopList = openShop.map((value) => {
    return (
      <li className="selectoption" key={value.id} onClick={() => selectEvent("shopStopSelect", value.id, value.name)}>{value.name}</li>
    );
  });
  // 임시 정지 중인 상점 리스트 생성
  const closeShopList = closeShop.map((value) => {
    return (
      <li className="selectoption" key={value.id} onClick={() => selectEvent("shopOpenSelect", value.id, value.name)}>{value.name}</li>
    );
  });

  // 셀렉트 이벤트
  const selectEvent = (target, id, name) => {
    const targetElement = document.querySelector(`#${target} .selectText`);
    targetElement.setAttribute("data-id", id);
    targetElement.innerText = name;

    if(target === "shopOpenSelect" && id !== 0) {
      /*getShopInfoApi(id).then((response) => {
        const startTs = response.pauseStartDateTime.slice(2, 16);
        const endTs = response.pauseEndDateTime.slice(2, 16);
        document.querySelector(".shopOpenTime").classList.remove("hide");
        document.querySelector(".shopOpenTime .startDay1").innerText = startTs;
        document.querySelector(".shopOpenTime .endDay1").innerText = endTs;
      });*/
    } else {
      document.querySelector(".shopOpenTime").classList.add("hide");
    }
  }


  // 영업정지 팝업 출력 이벤트
  const stopPopupEvent = () => {
    const time = getTime().split(":");

    const hours1 = Number(time[0]);
    const minutes1 = Number(time[1]);
    let hours2 = Number(time[0])
    let minutes2 = Number(time[1]) + 10;

    if(minutes2 >= 60) {
      hours2 += 1;
      minutes2 -= 60;
    }
    if(hours2 >= 24) {
      hours2 -= 24;
    }

    setValue("startDay1", String(hours1).padStart(2, '0'));
    setValue("startDay2", String(minutes1).padStart(2, '0'));
    setValue("endDay1", String(hours2).padStart(2, '0'));
    setValue("endDay2", String(minutes2).padStart(2, '0'));
    document.querySelector("#shopStopSelect .selectTextBox").setAttribute("data-id", "0");
    document.querySelector("#shopStopSelect .selectTextBox").innerText = "미선택";

    openPopup("stopPopup");
  }

  // 시간 변경 이벤트
  const timeChangeEvent = (targetId, timeType, number) => {
    const targetValue = Number(getValue(targetId));

    if(timeType === 1) {
      // 시간일 경우
      if(targetValue + number > 23) {
        alert("0시~23시까지 설정할 수 있습니다.");
      } else {
        setValue(targetId, String(targetValue + number).padStart(2, '0'));
      }
    } else if(timeType === 2) {
      // 분일 경우
      if(targetValue + number > 59) {
        alert("0분~59분까지 설정할 수 있습니다.");
      } else {
        setValue(targetId, String(targetValue + number).padStart(2, '0'));
      }
    }
  }

  // 영업 임시 정지 이벤트
  const shopStopBtnEvent = async () => {
    const shopId = Number(document.querySelector("#shopStopSelect .selectTextBox").getAttribute("data-id"));
    const shopName = document.querySelector("#shopStopSelect .selectTextBox").innerText;
    const today = new Date();
    const startTime = getValue("startDay1") + getValue("startDay2");
    const endTime = getValue("endDay1") + getValue("endDay2");

    if (shopId === 0) {
      alert("상점을 선택해주세요.");
      return false;
    }
    if (startTime.length !== 4) {
      alert("시작 시간을 입력해주세요.");
      return false;
    }
    if (endTime.length !== 4) {
      alert("종료 시간을 입력해주세요.");
      return false;
    }

    // 날짜 계산 도우미
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    const getFormattedDateTime = (date, hour, min, sec) => {
      return `${formatDate(date)} ${hour}:${min}:${sec}`;
    };

    const startHour = getValue("startDay1");
    const startMin = getValue("startDay2");
    const endHour = getValue("endDay1");
    const endMin = getValue("endDay2");

    const startDate = new Date(today); // 기본: 오늘
    let endDate = new Date(today);     // 기본: 오늘

    const startNum = parseInt(startHour + startMin);
    const endNum = parseInt(endHour + endMin);

    if (startNum > endNum) {
      // 종료 시간이 시작 시간보다 빠르면 종료일은 내일
      endDate.setDate(endDate.getDate() + 1);
    } else if (startNum === endNum) {
      // 시작과 종료가 같은 경우도 다음 날로 처리할지 현재 기준에서 판단
      endDate.setDate(endDate.getDate() + 1);
    }

    const startTs = getFormattedDateTime(startDate, startHour, startMin, "00");
    const endTs = getFormattedDateTime(endDate, endHour, endMin, "59");

    await setShopPauseApi({
      shopId: shopId,
      startDateTime: startTs,
      endDateTime: endTs
    });

    document.querySelector("#stopPopup2 .stop2Time span").innerText = `${startHour}:${startMin}~${endHour}:${endMin}`;
    document.querySelector("#stopPopup2 .stop2Name span").innerText = shopName;
    openPopup("stopPopup2");
  };

  const shopOpenBtnEvent = async () => {
    const shopTextBox = document.querySelector("#shopOpenSelect .selectTextBox");
    const shopId = Number(shopTextBox.getAttribute("data-id"));

    if(shopId === 0) {
      alert("상점을 선택해주세요.");
      return;
    }

    const shopName = shopTextBox.innerText;

    await setShopPauseApi({
      shopId: shopId
    });

    document.querySelector("#openPopup2 .stop2Name span").innerText = shopName;

    openPopup("openPopup2");
  }

  return (
    <div>
      <div id="stopChoicePopup" className='stopChoicePopup popupV2 hide'>
        <div className='popupContainer width436'>
          <div className='popupTitle'>
            <button className='closeBtn stopCloseBtn' onClick={() => closePopup("stopChoicePopup")}>
              <img src={closeV2} alt='취소' />
            </button>
          </div>
          <div className='popupContent shopChoiceBox'>
            <button className='openBtn' onClick={stopPopupEvent}><img src={ closeBtn } alt="닫기" /></button>
            <button className='openBtn' onClick={() => openPopup("openPopup")}><img src={ openBtn } alt="열기" /></button>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn oneBtn' onClick={() => closePopup("stopChoicePopup")}>닫기</button>
          </div>
        </div>
      </div>

      <div id="stopPopup" className='stopPopup popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>영업일시중지 설정</h2>
            <button className='closeBtn stopCloseBtn' onClick={() => closePopup("stopPopup")}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <div className='popupFlexBox popupFlexBox1'>
              <div className='flexTitle'>상점</div>
              <div className='flexContent'>
                <div id='shopStopSelect' className='popupSelect select selectBox'>
                  <div className="selectText selectTextBox" data-href='shopStopSelect' data-id="0">미선택</div>
                  <ul id="shopStopSelectUl" className='selectOptionListBox selectOptionList' data-href='shopStopSelect'>
                    <li className="selectoption" onClick={() => selectEvent("shopStopSelect", 0, "미선택")}>미선택</li>
                    {openShopList}
                  </ul>
                </div>
              </div>
            </div>
            <div className='popupFlexBox'>
              <div className='flexTitle'>일시중지 시간</div>
              <div className='flexContent stopInputListBox'>
                <div className='stopInputList'>
                  <button className='plusBtn1 plusBtn' onClick={() => timeChangeEvent("startDay1", 1, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='startDay1' />
                  <button className='minusBtn1 minusBtn' onClick={() => timeChangeEvent("startDay1", 1, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
                <span>:</span>
                <div className='stopInputList'>
                  <button className='plusBtn2 plusBtn' onClick={() => timeChangeEvent("startDay2", 2, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='startDay2' />
                  <button className='minusBtn2 minusBtn' onClick={() => timeChangeEvent("startDay2", 2, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
                <span className='spanCenter'>~</span>
                <div className='stopInputList'>
                  <button className='plusBtn1 plusBtn' onClick={() => timeChangeEvent("endDay1", 1, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='endDay1' />
                  <button className='minusBtn1 minusBtn' onClick={() => timeChangeEvent("endDay1", 1, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
                <span>:</span>
                <div className='stopInputList'>
                  <button className='plusBtn2 plusBtn' onClick={() => timeChangeEvent("endDay2", 2, 1)}><img src={ plusBtn } alt='플러스 버튼' /></button>
                  <input type='number' id='endDay2' />
                  <button className='minusBtn2 minusBtn' onClick={() => timeChangeEvent("endDay2", 2, -1)}><img src={ minusBtn } alt='마이너스 버튼' /></button>
                </div>
              </div>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn stopCloseBtn' onClick={() => closePopup("stopPopup")}>취소</button>
            <button type='button' className='stopBtn blueBtn' onClick={shopStopBtnEvent}>확인</button>
          </div>
        </div>
      </div>

      <div id="stopPopup2" className='stopPopup2 popupV2 hide'>
        <div className='popupContainer width436'>
          <div className='popupTitle'>
            <button className='closeBtn stop2CloseBtn' onClick={reloadPopup}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <p className='stop2Time'>영업일시중지(<span></span>)가<br />설정되었습니다.</p>
            <p className='stop2Name'>(상점 : <span></span>)</p>
          </div>
          <div className='popupBtn'>
            <button type='button' className='blueBtn oneBtn' onClick={reloadPopup}>확인</button>
          </div>
        </div>
      </div>

      <div id="openPopup" className='openPopup popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>영업일시중지 해제</h2>
            <button className='closeBtn' onClick={() => closePopup("openPopup")}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <div className='popupContentTitle'>일시중지 중인 상점</div>
            <div className='flexContent'>
              <div id='shopOpenSelect' className='popupSelect select selectBox'>
                <div className='selectText selectTextBox' data-href='shopOpenSelect' data-id="0">미선택</div>
                <ul id="shopOpenSelectUl" className='selectOptionListBox selectOptionList' data-href='shopOpenSelect'>
                  <li className='selectoption' onClick={() => selectEvent("shopOpenSelect", 0, "미선택")}>미선택</li>
                  {closeShopList}
                </ul>
              </div>
              <p className='shopOpenTime hide'>
                <span className='startDay1'></span>&nbsp;~&nbsp;
                <span className='endDay1'></span>&nbsp;
                <span className='red'>일시중지 설정 중</span>
              </p>
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn' onClick={() => closePopup("openPopup")}>취소</button>
            <button type='button' className='shopOpenBtn blueBtn' onClick={shopOpenBtnEvent}>확인</button>
          </div>
        </div>
      </div>

      <div id="openPopup2" className='openPopup2 popupV2 hide'>
        <div className='popupContainer width436'>
          <div className='popupTitle'>
            <button className='closeBtn' onClick={reloadPopup}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <p className='stop2Time'>영업일시중지가<br />해제되었습니다.</p>
            <p className='stop2Name'>(상점 : <span></span>)</p>
          </div>
          <div className='popupBtn'>
            <button type='button' className='blueBtn oneBtn' onClick={reloadPopup}>확인</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopStopPopup;